module.exports = __webpack_public_path__ + "img/t_0012.46b95bfe.gif";